const MAIN_PATH = '/app/cash-registers'

const cashRegistersPathnames = {
  CASH_REGISTERS: `${MAIN_PATH}`,
}

export { cashRegistersPathnames }
